import React, { useState } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { ReactComponent as IconAccordionExpand18 } from "../../icons/icon/18/a-icon-accordeon-expand-18.svg";
import { ReactComponent as IconAccordionMinimize18 } from "../../icons/icon/18/a-icon-accordeon-minimize-18.svg";
import BrowserDetection from "../../utils/browserDetection";

import "./footerSection.scss";

const FooterSection = ({
  children = null,
  sectionName,
}) => {
  const [isSectionExpanded, setIsSectionExpanded] = useState(false);

  const isMobile = BrowserDetection.hasTouchScreen();

  return (
    <Accordion className="footer-section">
      <Card>
        <Accordion.Toggle
          as="div"
          eventKey="0"
          onClick={() => {
            setIsSectionExpanded((prevState) => !prevState);
          }}
        >
          <Row className={classNames("footer-section__header", { "footer-section__header--active": isSectionExpanded })}>
            <Col xs={10} sm={11} className={classNames("footer-section__section-name", { mobile: isMobile })}>
              {sectionName}
            </Col>
            <Col xs={2} sm={1} className="d-lg-none justify-content-end d-flex">
              {
                isSectionExpanded
                  ? <IconAccordionMinimize18 className="footer-section__icon" />
                  : <IconAccordionExpand18 className="footer-section__icon" />
              }
            </Col>
          </Row>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="0">
          <Card.Body>
            {children}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

FooterSection.propTypes = {
  children: PropTypes.node,
  sectionName: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};

export default FooterSection;
